import axios from "axios";
import { url } from "../baseUrl";

export const UploadStore = {
  state: {
    total_uploads: 0,
    latest_upload_at: "",
    upload_number: [],
    dates: [],
    upload_number_array: [],

    latest_upload: null,
  },
  mutations: {
    getUploadInfo(state, data) {
      state.total_uploads = data.total_uploads;
      state.latest_upload = data.latest_upload;
      let initialDate = data.latest_upload.upload_at.split("T")[0];
      let date = new Date(initialDate);
      let list = date.toUTCString().split(" ");
      let year = list[3].substring(2, 4);
      state.latest_upload_at = list[1] + " " + list[2] + " " + year;
    }
  },
  actions: {
    fileUpload(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/uploads/",
          data: data,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Token " + auth_token
          },
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    uploadInfo(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/uploadinfo/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getUploadInfo", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    uploadNumber(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url:
            url.baseUrl + "/configuration/uploadgraph/?filter=" + data.filter,
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    dates: state => {
      return state.dates;
    },
    uploadcounts: state => {
      return state.upload_number;
    }
  }
};
